// providers
import D2C_AWS from '@/assets/logos/providers/AWS.png'
import D2C_Backblaze from '@/assets/logos/providers/Backblaze.png'
import D2C_Custom from '@/assets/logos/providers/Custom.png'
import D2C_D2C from '@/assets/logos/providers/D2C.png'
import D2C_DO from '@/assets/logos/providers/DO.png'
import D2C_Dropbox from '@/assets/logos/providers/Dropbox.png'
import D2C_FTP from '@/assets/logos/providers/FTP.png'
import D2C_GCP from '@/assets/logos/providers/GCP.png'
import D2C_GELF from '@/assets/logos/providers/gelf.png'
import D2C_Hubic from '@/assets/logos/providers/Hubic.png'
import D2C_OneDrive from '@/assets/logos/providers/OneDrive.png'
import D2C_S3 from '@/assets/logos/providers/S3.png'
import D2C_SFTP from '@/assets/logos/providers/SFTP.png'
import D2C_Spaces from '@/assets/logos/providers/Spaces.png'
import D2C_Upcloud from '@/assets/logos/providers/Upcloud.png'
import D2C_Vultr from '@/assets/logos/providers/Vultr.png'
import D2C_Provider from '@/assets/logos/providers/unknown.svg'
// services
import D2C_crate from '@/assets/logos/services/crate.png'
import D2C_docker from '@/assets/logos/services/docker.png'
import D2C_elasticsearch from '@/assets/logos/services/elasticsearch.png'
import D2C_etcd from '@/assets/logos/services/etcd.png'
import D2C_go from '@/assets/logos/services/go.png'
import D2C_haproxy from '@/assets/logos/services/haproxy.png'
import D2C_mariadb from '@/assets/logos/services/mariadb.png'
import D2C_memcached from '@/assets/logos/services/memcached.png'
import D2C_mongodb from '@/assets/logos/services/mongodb.png'
import D2C_mysql from '@/assets/logos/services/mysql.png'
import D2C_nginx from '@/assets/logos/services/nginx.png'
import D2C_nginxCluster from '@/assets/logos/services/nginxCluster.png'
import D2C_nginxStatic from '@/assets/logos/services/nginxStatic.png'
import D2C_nodejs from '@/assets/logos/services/nodejs.png'
import D2C_percona from '@/assets/logos/services/percona.png'
import D2C_php from '@/assets/logos/services/php.png'
import D2C_phpApache from '@/assets/logos/services/phpApache.png'
import D2C_phpNginx from '@/assets/logos/services/phpNginx.png'
import D2C_postgres from '@/assets/logos/services/postgres.png'
import D2C_python from '@/assets/logos/services/python.png'
import D2C_redis from '@/assets/logos/services/redis.png'
import D2C_ruby from '@/assets/logos/services/ruby.png'
import D2C_skydns from '@/assets/logos/services/skydns.png'
import D2C_varnish from '@/assets/logos/services/varnish.png'
import D2C_Service from '@/assets/logos/services/unknown.svg'
// unknown
import unknown from '@/assets/logos/unknown.png'

export default {
  providers: {
    AWS: D2C_AWS,
    Backblaze: D2C_Backblaze,
    custom: D2C_Custom,
    D2C: D2C_D2C,
    DO: D2C_DO,
    Dropbox: D2C_Dropbox,
    FTP: D2C_FTP,
    GCP: D2C_GCP,
    gelf: D2C_GELF,
    Hubic: D2C_Hubic,
    OneDrive: D2C_OneDrive,
    S3: D2C_S3,
    SFTP: D2C_SFTP,
    Spaces: D2C_Spaces,
    Upcloud: D2C_Upcloud,
    Vultr: D2C_Vultr,
    unknown: D2C_Provider,
  },
  services: {
    crate: D2C_crate,
    docker: D2C_docker,
    elasticsearch: D2C_elasticsearch,
    etcd: D2C_etcd,
    go: D2C_go,
    haproxy: D2C_haproxy,
    mariadb: D2C_mariadb,
    memcached: D2C_memcached,
    mongodb: D2C_mongodb,
    mysql: D2C_mysql,
    nginx: D2C_nginx,
    nginxCluster: D2C_nginxCluster,
    nginxStatic: D2C_nginxStatic,
    nodejs: D2C_nodejs,
    percona: D2C_percona,
    php: D2C_php,
    phpApache: D2C_phpApache,
    phpNginx: D2C_phpNginx,
    postgres: D2C_postgres,
    python: D2C_python,
    redis: D2C_redis,
    ruby: D2C_ruby,
    skydns: D2C_skydns,
    varnish: D2C_varnish,
    unknown: D2C_Service,
  },
  unknown,
}
